import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'docomo Open Inovation Cloud',
  title1: 'docomo Open Inovation Cloud',
  introduction_text:
    '5G関連サービス「ドコモオープンイノーべションクラウド」を開発いたしました。このサービスは、5Gを活用したサービス開発者向けのものです。弊社はプロジェクト支援、サービス設計、クラウドをフル活用したサーバーレスアーキテクチャでのウェブシステムの開発を実施しました。',
  company: '株式会社NTTドコモ',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  tag3text: 'フロントエンド開発',
  tag3src: '/cases/uxui-improvement/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '',
  background: '#AAD4F2',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/ntt.webp',
  alt: 'docomo Open Inovation Cloud',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'クラウドネイティブで新システム開発のご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '当社ではドコモ社が推進する5G関連サービス「ドコモオープンイノーべションクラウド」の開発者向けサービスを充実させるためのプロジェクト支援、サービス設計、クラウドをフル活用したサーバーレスアーキテクチャでのウェブシステムの開発を支援させていただいております。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'モダンな言語やフレームワークでのサービス構築経験が少ない',
        text: '',
      },
      {
        title: 'サービス企画が明確でない',
        text: '',
      },
      {
        title: 'ミドルB向けのサービス展開の知見がない',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'クラウドをフル活用したウェブシステム開発の支援',
        text: '',
      },
      {
        title: 'プロジェクト支援フェーズから参画し、サービス企画の明確化',
        text: '',
      },
      {
        title: '豊富な実績を活かしたサービス展開の支援',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
